export const SESSION_TYPES = Object.freeze({
  AUTOMY: 'automy',
  PORTAL: 'portal',
  APP: 'app',
});

export const SESSION_INDEX_KEY = 'session-current';

export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth-token',
  AUTH_USER: 'auth-user',
  USER_CONTEXT: 'user-context',
  TWO_FACTOR_STATE: 'auth-2FA-state',
  AUTHORITY: 'authority',
  USER_TIMEZONE: 'user-timezone',
  PORTAL_CONFIG: 'config',
  APP_CONFIG: 'config',
  AUTH_REFRESHING: 'auth-refreshing',
  AUTH_TOKEN_REFRESH: 'auth-token-refresh',
  LOGOUT_IN_PROGRESS: 'logout-in-progress',
  /** Last restorable identity. New tabs restore only this user, not the newest token. */
  SESSION_OWNER: 'session-owner',
  APP_LOGIN_CONTEXT: 'app-login-appId',
  /** Set only after a successful app login, while the tab is still off `/apps/:id`. */
  APP_LOGIN_HANDOFF: 'app-login-handoff',
  APP_REDIRECT_AFTER_LOGIN: 'app-redirect-after-login',
  /** Set when leaving /user/login?app= for Google/Microsoft. Survives /?code=. */
  APP_OAUTH_PENDING: 'app-oauth-pending',
  /** Selector → /p/ handoff so mint can use portal.id if /auth/portal slug mismatches. */
  PORTAL_LOGIN_HANDOFF: 'portal-login-handoff',
  /** Set on `/user/login?portal=` before Google/Microsoft. Survives `/?code=`. */
  PORTAL_OAUTH_PENDING: 'portal-oauth-pending',
  APP_AUTH_CONFIG_PREFIX: 'app-auth-config-',
  SSO_REDIRECT_URL: 'sso-redirect-url',
  SSO_CLIENT_ID: 'sso-client-id',
  SSO_AUTOMATIC_FLOW: 'sso-automatic-flow',
  SSO_PROVIDER: 'sso-provider',
  SSO_AUTO_DISABLED: 'sso-auto-disabled',
  SSO_CLIENT_VALIDATED: 'sso-client-validated',
  SSO_SESSION_ID: 'sso-session-id',
  OPERATIONAL_AUTH_BLOCK: 'operational-auth-block',
  /** Short-lived Stripe round-trip handoff only — not a general restricted-token store. */
  RESTRICTED_BILLING_CHECKOUT_HANDOFF: 'restricted-billing-checkout-handoff',
};

export const MIGRATION_KEYS = [
  STORAGE_KEYS.AUTH_TOKEN,
  STORAGE_KEYS.AUTH_USER,
  STORAGE_KEYS.USER_CONTEXT,
  STORAGE_KEYS.AUTHORITY,
  STORAGE_KEYS.USER_TIMEZONE,
  STORAGE_KEYS.TWO_FACTOR_STATE,
];

export const SSO_STORAGE_KEYS = [
  STORAGE_KEYS.SSO_REDIRECT_URL,
  STORAGE_KEYS.SSO_CLIENT_ID,
  STORAGE_KEYS.SSO_AUTOMATIC_FLOW,
  STORAGE_KEYS.SSO_PROVIDER,
  STORAGE_KEYS.SSO_AUTO_DISABLED,
  STORAGE_KEYS.SSO_CLIENT_VALIDATED,
  STORAGE_KEYS.SSO_SESSION_ID,
];

export const PKCE_STORAGE_KEYS = [
  'google_oauth_code_verifier',
  'google_oauth_state',
  'microsoft_oauth_code_verifier',
  'microsoft_oauth_state',
];

// Keys that hold credentials. When a session dies these must be dropped from
// every namespace of the user (automy/portal/app), otherwise a token left in an
// unrelated namespace is later picked up as a live session by tryRestoreSession.
export const AUTH_SESSION_KEYS = [
  STORAGE_KEYS.AUTH_TOKEN,
  STORAGE_KEYS.AUTH_USER,
  STORAGE_KEYS.USER_CONTEXT,
  STORAGE_KEYS.AUTHORITY,
  STORAGE_KEYS.AUTH_REFRESHING,
  STORAGE_KEYS.AUTH_TOKEN_REFRESH,
  STORAGE_KEYS.TWO_FACTOR_STATE,
];
